import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-speak-up',
  templateUrl: './speak-up.component.html',
  styleUrls: ['./speak-up.component.scss']
})
export class SpeakUpComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
